module.exports = __webpack_public_path__ + "img/inside_thumb.b5ce0d25.jpg";